/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { LineItemFromState } from '@/types/reduxStore/orders';
import type { CartAnalytics } from './types';
import type { Order, OrderDetailsData } from '@/types/index';

export default function cartAnalyticsAdapter(orderDetails: OrderDetailsData): CartAnalytics {
  const orders = orderDetails?.orders || [];
  const lineItems = getLineItemsFromOrderDetails(orders);

  return lineItems.reduce(
    (result: CartAnalytics, lineItem) => {
      const { lineItemPriceInfo, productInfo } = lineItem || {};
      const { corePrice, discountPrice, unitPrice } = lineItemPriceInfo || {};
      const { partNumber, skuId, skuDisplayName, brand } = productInfo || {};
      return {
        cartCorePrice: [...result.cartCorePrice, corePrice],
        cartDiscountPriceList: [...result.cartDiscountPriceList, discountPrice],
        cartProductPartIds: [...result.cartProductPartIds, partNumber],
        cartProductSkus: [...result.cartProductSkus, skuId],
        cartProductTitles: [...result.cartProductTitles, skuDisplayName],
        cartProductVendors: [...result.cartProductVendors, brand],
        cartUnitPrice: [...result.cartUnitPrice, unitPrice as unknown as string],
      };
    },
    {
      cartCorePrice: [],
      cartDiscountPriceList: [],
      cartProductPartIds: [],
      cartProductSkus: [],
      cartProductTitles: [],
      cartProductVendors: [],
      cartUnitPrice: [],
    },
  );
}

function getLineItemsFromOrderDetails(orders: Order[]) {
  return orders.reduce<LineItemFromState[]>((result, order) => {
    const shipmentInfoList = order.shipmentInfoList || [];

    shipmentInfoList.forEach((shipmentInfo) => {
      if (shipmentInfo && shipmentInfo.lineItemList) {
        result.push(...shipmentInfo.lineItemList);
      }
    });

    return result;
  }, []);
}
